// extracted by mini-css-extract-plugin
export default {"link":"style_link__EskFc","icon":"style_icon__F9UaI","content":"style_content__nHY7v"};